export type SupplierAssociationDisplay = {
  "Supplier Name": string;
  "Branch Name": string;
  "Branch Code": string;
  "Supplier Code": string;
  "Customer Type": string;
  Discount: string;
};

const DISPLAY_FIELDS: (keyof SupplierAssociationDisplay)[] = [
  "Supplier Name",
  "Branch Name",
  "Branch Code",
  "Supplier Code",
  "Customer Type",
  "Discount",
];

export const SUPPLIER_ASSOCIATION_DISPLAY_FIELDS = DISPLAY_FIELDS;

function resolveSupplier(association: any, allSuppliers?: any[]) {
  const supplierId =
    association?.supplierId?.toString?.() ?? association?.supplierId;

  if (association?.supplier) {
    return association.supplier;
  }

  return allSuppliers?.find(
    (supplier: any) => supplier._id?.toString() === supplierId?.toString(),
  );
}

function resolveBranch(association: any, supplier: any) {
  const branchId =
    association?.supplierBranchId?.toString?.() ??
    association?.supplierBranchId;

  if (!supplier?.branches?.length) {
    return undefined;
  }

  return (
    supplier.branches.find(
      (branch: any) => branch._id?.toString() === branchId?.toString(),
    ) ?? supplier.branches[0]
  );
}

export function formatSupplierAssociationForDisplay(
  association: any,
  allSuppliers?: any[],
): SupplierAssociationDisplay {
  const supplier = resolveSupplier(association, allSuppliers);
  const branch = resolveBranch(association, supplier);

  return {
    "Supplier Name": supplier?.businessName || supplier?.name || "-",
    "Branch Name": branch?.branchName || "-",
    "Branch Code": branch?.branchCode || "-",
    "Supplier Code": association?.supplierCode || "-",
    "Customer Type": association?.customerType || "-",
    Discount:
      association?.discount != null && association?.discount !== ""
        ? String(association.discount)
        : "-",
  };
}

export function formatSupplierAssociationsForDisplay(
  associations: any[] | undefined,
  allSuppliers?: any[],
): SupplierAssociationDisplay[] {
  if (!associations?.length) {
    return [];
  }

  return associations.map((association) =>
    formatSupplierAssociationForDisplay(association, allSuppliers),
  );
}
